import React, { useState } from 'react';
import TogglerBody from '../../../template/TogglerBody';

const SystemStatusItem = ({item, isActive}) => {
    const [isOn, setIsOn] = useState(isActive)
    
    return (

        <div className='system_status_item_wrap'>
            <img src={`/img/asside_icon/${item?.name}.svg`} alt="" />
            <p className='system_status_item_categories'>{item?.categories}</p>
            <h3 className='system_status_item_name'>{item?.name}</h3>
            <div className={`system_status_item_status ${isOn ? 'system_status_item_status_on' : 'system_status_item_status_off'}`}> <p>{isOn ? 'enabled' : 'disabled'}</p> </div>
            <div className='system_status_item_setting'>
                <img src="/img/asside_icon/SettingsActive.svg" alt="" />
                <TogglerBody
                    keyName={item?.keyName}
                    setIsOn={setIsOn}
                    isOn={isOn}
                /> 
            </div>
            <div className='system_status_item_psevdo_bg_all'></div>
            <div className='system_status_item_psevdo_bg'></div>
        </div>

    );
};

export default SystemStatusItem;